import {useQuery} from 'react-query';
import getHomepageLabNotifModal from './getHomepageLabNotifModal';

const useGetHomepageLabNotifModal = () => {
  const {data, isLoading} = useQuery(
    ['get-homepage-lab-notif-modal'],
    getHomepageLabNotifModal,
    {
      staleTime: 0,
      cacheTime: 0,
      refetchOnMount: 'always',
    },
  );

  return {labModal: data, isLoading};
};

export default useGetHomepageLabNotifModal;
